import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useAxios from '../../hooks/useAxios';
import useToasts from '../../hooks/useToasts';
import SvgGoogle from '../../shared/icons/SvgGoogle';
import { googleLogin } from '../../_util/api';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

function hideAuthModal() {
  const backdrop = document.querySelector('.modal-backdrop');
  if (backdrop) {
    backdrop.remove(); // Remove the modal backdrop if user is not null
    const body = document.querySelector('body');
    body.style.overflow = 'auto';
    body.style.padding = '0px';
  }
}

function GoogleLoginPopup() {
  const navigate = useNavigate();
  const { addToast } = useToasts();
  const { loginUser } = useAuth();
  const { isLoading, makeRequest } = useAxios({
    onSuccess: (res) => {
      loginUser(res);

      const isBuyBoostButtonClicked = localStorage.getItem('buy-boost-button-clicked');
      const isBuyAccountButtonClicked = localStorage.getItem('buy-account-clicked');
      if (!isBuyBoostButtonClicked && !isBuyAccountButtonClicked) {
        //when direct login then it should redirect to the dashboard
        navigate('/admin/dashboard');
      } else {
        // login if user is not login and try to place order
        addToast('Login successfull. Redirecting to Stripe...', 'success');
      }
      hideAuthModal();
    },
    onError: (err) => addToast(err, 'danger'),
  });

  const handleCredentialResponse = (response) => {
    // Handle successful login
    makeRequest(
      googleLogin({
        credential: response.credential,
        userType: 'customer',
      }),
    );
  };

  const loadGoogleSignInAPI = () => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = initializeGoogleSignIn;
  };

  const initializeGoogleSignIn = () => {
    window.google?.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
      cancel_on_tap_outside: true, // Allow users to click outside the popup to cancel
      prompt_parent_id: 'google-signin-popup', // Provide the ID of the parent element for the popup
    });
  };

  const handleGoogleLogin = () => {
    const name = 'g_state';
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.google?.accounts.id.prompt();
  };

  // Not needed because it's already loaded in index.html
  // useEffect(() => {
  //   loadGoogleSignInAPI();
  // }, []);

  //   const popupContainer = document.getElementById('google-signin-popup');
  //   const googleSigninButton = document.getElementById('google-signin-button');

  // // Add a click event listener to the document
  // document.addEventListener('click', (event) => {
  //   if (popupContainer || event.target !== googleSigninButton) {
  //     window.google?.accounts.id.cancel();
  //   }
  // });
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div style={{ borderRadius: '50px' }} className="social-login-google">
        <GoogleLogin
          size="large"
          text="continue_with"
          shape="pill"
          logo_alignment="center"
          locale="en-GB"
          width="200px"
          onSuccess={(credentialResponse) => {
            const decoded = jwtDecode(credentialResponse.credential);
            makeRequest(
              googleLogin({
                credential: credentialResponse.credential,
                userType: 'customer',
              }),
            );
          }}
          onError={() => {
            console.log('Login Failed');
          }}
        />
      </div>

      {/* <button
        type="button"
        className="btn btn-primary"
        style={{ background: 'white' }}
        onClick={handleGoogleLogin}
      >
        <SvgGoogle />
        {isLoading && (
          <div className="spinner-border text-dark" role="status">
            <span className="sr-only"></span>
          </div>
        )}
        {!isLoading && 'Continue with Google'}
      </button> */}
    </GoogleOAuthProvider>
  );
}

export default GoogleLoginPopup;
